export const APP_SUMO_TIERS = [
  'edee_tier1', 'edee_tier2', 'edee_tier3', 'edee_tier4', 'edee_tier5'
]
